"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "m24.005 6.072-8.545.552L10.16 0 8.037 8.16.005 11.088l7.251 4.488L7.598 24l6.592-5.376 8.252 2.28-3.174-7.824 4.737-7.008Zm-5.371 4.776c-.074.048-.147.096-.22.12a.532.532 0 0 1-.415-.12c0-.024-.025-.048-.073-.072-.342 1.8-1.807 3.696-4.468 4.248-2.735.576-4.957-.624-5.933-2.16 0 .024-.025.072-.025.096a.411.411 0 0 1-.341.36.371.371 0 0 1-.171.024.454.454 0 0 1-.367-.504c.098-.528.415-.936.928-1.176.366-.168.708-.216.733-.216a.439.439 0 0 1 .488.384.435.435 0 0 1-.39.48s-.074 0-.147.024c.928 1.632 3.223 2.232 5.03 1.848 2.343-.504 3.564-2.136 3.832-3.672a.459.459 0 0 0-.17.048c-.22.12-.489.048-.586-.168a.422.422 0 0 1 .146-.576c.488-.264 1.001-.264 1.538-.024.342.192.586.408.61.432.172.192.172.456 0 .624Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};